
import React from 'react';

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';


function Cell() {
	const [cell, setCell] = React.useState("");

	const handleCell = (e) => {
		const n = e.target.value
		setCell(n);
	};

	return (
		<Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems="center">
			<Grid item xs={4} md={6}>
				<Typography variant='subtitle1' sx={{ marginTop: "20px", textAlign: "center", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold", color: "#fff" }}>
				Il tuo cellulare
				</Typography>
			</Grid>
			<Grid item xs={8} md={6}>
				<TextField
					id="telefono"
					label="Cellulare"
					value={cell}
					name="cell"
					variant="standard"
					sx={{ m: 1 }}
					required
					onChange={(e) => handleCell(e)}
					inputProps={{maxLength: 99, style: {fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold", color: "#fff"}}} 
          			InputLabelProps={{style: {fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold", color: "#fff"}}}  
				/>
			</Grid>
		</Grid>
	)
}

export default Cell;